module.exports = __webpack_public_path__ + "img/pdf-icon.bd6516be.png";